export default __webpack_public_path__ + "static/hani-62a91f7f83c3d64fba23447b5ab247f5.png";